module.exports = __webpack_public_path__ + "img/cavans-bg.ff4eac7d.png";